<ui-drawer [hasBackdrop]="drawers[Drawers.SIDENAV].mode === 'over' && drawers[Drawers.SIDENAV].open"
    (backdropAction)="closeDrawers()">

    <drawer [open]="drawers[Drawers.SIDENAV].open" *ngIf="hideCompService.visibleSideMenu" [mode]="drawers[Drawers.SIDENAV].mode"
        (window:resize)="positionSidenav($event)" class="alt">
        <!-- * Left menu -->
        <app-side-menu (statusDrawer)="closeDrawers()"></app-side-menu>
    </drawer>

    <drawer-main>
        <!-- * Header -->
        <app-header [sidenavToggle]="drawers[Drawers.SIDENAV].displaced" (toggleNavMenu)="toggleDrawer($event)"
            (toggleDrawerUser)="toggleDrawer($event)" (toggleDrawerNotif)="toggleDrawer($event)"
            (userDetails)="onGetUser($event)">
        </app-header>

        <ui-drawer [hasBackdrop]="drawers[Drawers.NOTIFICATIONS].open || drawers[Drawers.USER_DETAILS].open"
            (backdropAction)="closeDrawers()">

            <empty-state id="empty-state_1700662322" *ngIf="sessionExpired" maxWidth="800px" imgMaxWidth="380px"
                [image]="valuesService.centralImages.dipProtectionTimeout.link"
                [title]="'platform.user.session.expired.title' | translate"
                [details]="'platform.user.session.expired.details' | translate: {manufacturerName: productsConfigService.getManufacturerName(), siteName: configService.config.siteName}">
                <button id="button_1700662312" ui-button color="primary" class="my-1 px-3" (click)="relogin()">
                    {{ "platform.user.session.expired.continue" | translate }}
                </button>
            </empty-state>

            <drawer-main *ngIf="!sessionExpired">
                <ui-loader *ngIf="getLoadingApp()" size="3x" class="m-auto color-primary-10"></ui-loader>
                <!-- animation has event emiters for start / done you can tap into ex: (@outletFadeAnimation.done) -->
                <main *ngIf="!getLoadingApp()" [@outletFadeAnimation]="routeName">
                    <router-outlet></router-outlet>
                </main>
            </drawer-main>

            <drawer [width]="400" [(open)]="drawers[Drawers.USER_DETAILS].open" position="right"
            class="drawer-user-details default">
                <!-- * User menu -->
                <app-user-details (statusDrawer)="closeDrawers()"></app-user-details>
            </drawer>

            <drawer [width]="400" [(open)]="drawers[Drawers.NOTIFICATIONS].open" position="right"
                class="drawer-notifications default">
                <app-notifications [(open)]="drawers[Drawers.NOTIFICATIONS].open" (statusDrawer)="closeDrawers()"></app-notifications>
            </drawer>
        </ui-drawer>
    </drawer-main>
</ui-drawer>
